// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-panel-additional-links></molecule-panel-additional-links> </div> </div> ";
// Exports
module.exports = code;